import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'analytics-answer-your-business-questions',
  template: require('./analytics-answer-your-business-questions.component.html'),
  styles: [require('./../blog.component.scss'), require('./analytics-answer-your-business-questions.component.scss')]
})
export class AnalyticsAnswerYourBusinessQuestions extends BlogPage {

  title = 'How Big Data is a Game-Changer in Ocean-Container Shipping - Linescape';
  description = 'What is the most important question for your business today? Reducing costs? Increasing revenue? Optimizing transit times?';

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
    super.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/analytics-answer-your-business-questions/analytics-answer-your-business-questions.component.ts